// components/blocks/map/MapBlock.tsx

'use client';

import React from "react";
import Section from "@/components/partials/section";
import SectionHeader from "@/components/partials/section/header";

type MapBlockProps = {
    data: {
        alignment: string;
        content: {
            title: string;
            description: string;
            mapQuery: string;
        };
    };
};


export default function MapBlock({ data }: MapBlockProps) {
    const { alignment, content } = data;
    const { title, description, mapQuery } = content;

    const src = [
        "https://www.google.com/maps/embed/v1/place",
        `key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}`,
        `q=${encodeURIComponent(mapQuery)}`,
    ].join("?").replace("?q=", "&q=");


    return (
        <Section
            id="map">
            <div className="flex flex-col w-full">
                <div className="flex flex-col gap-8 md:gap-16">
                    <div className="flex flex-col flex-1">
                        <SectionHeader
                            classGroup={{ h1: "text-3xl sm:text-6xl", description: "text-lg" }}
                            alignment={alignment}
                            title={title}
                            description={description}
                        />
                    </div>
                    <div className="flex flex-col flex-1 relative">
                        <iframe
                            title={`Map of ${title}`}
                            width="100%"
                            height="400"
                            loading="lazy"
                            allowFullScreen
                            src={src}
                        />
                    </div>
                </div>
            </div>
        </Section>
    );
}
